import React, { useState } from 'react';
import RoomManagement from './AdminTabs/RoomManagement';
import RoomTypeManagement from './AdminTabs/RoomTypeManagement';
import RoomPhotoManagement from './AdminTabs/RoomPhotoManagement';
import UserManagement from './AdminTabs/UserManagement';
import VoucherManagement from './AdminTabs/VoucherManagement';
import BlockedDatesManagement from './AdminTabs/BlockedDatesManagement';
import FlagManagement from '../components/FlagManagement';
import Reports from './AdminTabs/Reports';
import SeasonalPricing from './AdminTabs/SeasonalPricing';
import PaymentSettings from './AdminTabs/PaymentSettings';

const Admin = () => {
  const [activeTab, setActiveTab] = useState('roomTypes');

  const renderActiveTab = () => {
    switch (activeTab) {
      case 'roomTypes':
        return <RoomTypeManagement />;
      case 'rooms':
        return <RoomManagement />;
      case 'roomPhotos':
        return <RoomPhotoManagement />;
      case 'users':
        return <UserManagement />;
      case 'vouchers':
        return <VoucherManagement />;
      case 'blockedDates':
        return <BlockedDatesManagement />;
      case 'flags':
        return <FlagManagement />;
      case 'seasonalPricing':
        return <SeasonalPricing />;
      case 'paymentSettings':
        return <PaymentSettings />;
      case 'reports':
        return <Reports />;
      default:
        return <RoomManagement />;
    }
  };

  return (
    <div className="admin-container">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h1 className="admin-title" style={{ margin: 0 }}>Admin Panel</h1>
        <a 
          href="https://lacasitabeachresort.com/__admin__/#contacts" 
          target="_blank" 
          rel="noopener noreferrer"
          style={{
            padding: '10px 20px',
            backgroundColor: '#d4af37',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '5px',
            fontWeight: 'bold',
            fontSize: '14px',
            transition: 'background-color 0.3s'
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#c9a131'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#d4af37'}
        >
          ✉️ View Inquiries
        </a>
      </div>
      
      <div className="admin-tabs">
        <button
          className={`admin-tab ${activeTab === 'roomTypes' ? 'active' : ''}`}
          onClick={() => setActiveTab('roomTypes')}
        >
          Room Types
        </button>
        <button
          className={`admin-tab ${activeTab === 'rooms' ? 'active' : ''}`}
          onClick={() => setActiveTab('rooms')}
        >
          Rooms
        </button>
        <button
          className={`admin-tab ${activeTab === 'roomPhotos' ? 'active' : ''}`}
          onClick={() => setActiveTab('roomPhotos')}
        >
          Room Photos
        </button>
        <button
          className={`admin-tab ${activeTab === 'users' ? 'active' : ''}`}
          onClick={() => setActiveTab('users')}
        >
          Users
        </button>
        <button
          className={`admin-tab ${activeTab === 'vouchers' ? 'active' : ''}`}
          onClick={() => setActiveTab('vouchers')}
        >
          Vouchers
        </button>
        <button
          className={`admin-tab ${activeTab === 'blockedDates' ? 'active' : ''}`}
          onClick={() => setActiveTab('blockedDates')}
        >
          Blocked Dates
        </button>
        <button
          className={`admin-tab ${activeTab === 'flags' ? 'active' : ''}`}
          onClick={() => setActiveTab('flags')}
        >
          Flag Management
        </button>
        <button
          className={`admin-tab ${activeTab === 'seasonalPricing' ? 'active' : ''}`}
          onClick={() => setActiveTab('seasonalPricing')}
        >
          Seasonal Pricing
        </button>
        <button
          className={`admin-tab ${activeTab === 'paymentSettings' ? 'active' : ''}`}
          onClick={() => setActiveTab('paymentSettings')}
        >
          Payment Settings
        </button>
        <button
          className={`admin-tab ${activeTab === 'reports' ? 'active' : ''}`}
          onClick={() => setActiveTab('reports')}
        >
          Reports
        </button>
      </div>

      <div className="admin-content">
        {renderActiveTab()}
      </div>
    </div>
  );
};

export default Admin;
